import { Trans } from '@lingui/macro'
import { useRef, useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { PlainBrandIcon } from '@jotta/ui/BrandIcon'
import { Modal } from '@jotta/ui/Modal'
import SvgX from '@jotta/ui/SvgX'
import SvgLogo_iconLight from '@jotta/ui/SvgLogo_iconLight'
import { useBrandName } from '@jotta/grpc-connect-client/config'

export function AppPromotionDrawer({
  open,
  onLinkClick,
  onClose,
  downloadMobileAppLink,
}: {
  open: boolean
  onLinkClick: () => void
  onClose: () => void
  downloadMobileAppLink: string
}) {
  const brandName = useBrandName()
  const [closing, setClosing] = useState(false)
  const ref = useRef<HTMLDivElement>(null)
  return (
    <Modal open={open} onClose={() => setClosing(true)}>
      <AnimatePresence
        onExitComplete={() => {
          onClose()
          setClosing(false)
        }}
      >
        {!closing && (
          <motion.div
            className="fixed -bottom-[300px] flex w-full flex-col gap-8 rounded-t-xl border bg-primary p-8 pb-[332px]"
            ref={ref}
            drag="y"
            dragElastic={{
              top: 0,
              bottom: 1,
            }}
            dragConstraints={{ top: 0, bottom: 0 }}
            onDragEnd={(_, info) => {
              const clientHeight = ref.current?.clientHeight
              if (clientHeight && info.offset.y > (clientHeight - 300) / 2) {
                setClosing(true)
              }
            }}
            transition={{
              type: 'tween',
            }}
            initial={{ translateY: '100%' }}
            exit={{ translateY: '100%' }}
            animate={{ translateY: '0%' }}
          >
            <button
              className="absolute right-2 top-2 p-4"
              onClick={() => setClosing(true)}
            >
              <PlainBrandIcon icon={SvgX} height={24} />
            </button>
            <PlainBrandIcon icon={SvgLogo_iconLight} height={50} />
            <div className="text-center">
              <header className="h2">
                <Trans>Get the full app experience</Trans>
              </header>
              <p>
                <Trans>
                  Use the mobile app to make the most out of {brandName}
                </Trans>
              </p>
            </div>
            <a
              className="btn btn-primary"
              href={downloadMobileAppLink}
              onClick={() => onLinkClick()}
              rel="noreferrer"
            >
              <Trans>Download app</Trans>
            </a>
          </motion.div>
        )}
      </AnimatePresence>
    </Modal>
  )
}
